// The visitor's offer, for every surface of the page. It reads Shopify's cart once per change (load, a return to the
// tab, a cart update), applies window.vvOfferRules (snippets/vv-offer-rules.liquid) to the registry that
// snippets/vv-offers.liquid writes, and publishes the answer three ways: data-vv-offer, data-vv-offer-status and
// data-vv-shipping on <html>, window.vvOffer.state, and a vv:offer-change event on document whose detail is the state,
// with the cart's codes, item count and lines beside it.
// A surface reads the state or listens for the event; none reads the cart for its offer. Before this script runs,
// vv-offers.liquid has already applied the rules to the discount cookie for an empty cart, so a link's offer shows at
// first paint. state.ready turns true once a cart read has answered or failed.
// An offer whose entry names a companion free-shipping code, such as a win-back email's BRAN30 with BRAN30SHIP, gets
// that code added to the cart once the cart holds the offer's own code, since a /discount link carries one code.
(() => {
  if (window.vvOffer?.refresh || !window.vvOfferRules) return;
  const rules = window.vvOfferRules;
  let config = null;
  try { config = JSON.parse(document.getElementById('vv-offers')?.textContent || 'null'); } catch { config = null; }
  const offers = config?.offers || [];
  const customer = config?.customer || 'guest';
  const root = () => window.Shopify?.routes?.root || '/';
  const vvOffer = window.vvOffer = { state: { ...(window.vvOffer?.state || rules.decide({ offers: [] })), ready: false }, refresh };
  let latest = 0;

  function publish(state) {
    vvOffer.state = state;
    rules.write(document.documentElement, state);
    document.dispatchEvent(new CustomEvent('vv:offer-change', { detail: state }));
  }

  async function refresh() {
    const request = ++latest;
    try {
      const response = await fetch(`${root()}cart.js`, { cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      if (request !== latest) return;
      // Shopify's current cart decides; a code is never inferred from the URL or from storage.
      const cookie = rules.cookieCodes(document.cookie);
      // The cart's codes and item count go with the answer, so the pop-ups (vv-attention.js) read no cart of their own.
      const codes = (cart.discount_codes || []).map((entry) => String(entry.code || '').toUpperCase());
      const state = { ...rules.decide({ offers, cart, cookie, customer, now: Date.now() }), codes, items: cart.item_count || 0, lines: (cart.items || []).map(({ handle, price, quantity, final_line_price: final, original_line_price: original }) => ({ handle, price, quantity, final, original })), ready: true };
      publish(state);
      await addCompanion(cart, state.offer);
    } catch {
      // Without a current cart, the page promises no offer.
      if (request === latest) publish({ offer: null, status: '', shipping: 'threshold', rule: 0, ready: true, unavailable: true });
    }
  }

  // The offer's code and its companion shipping code, and nothing else, once the cart holds the offer's code.
  async function addCompanion(cart, offer) {
    const companion = offer?.shipping;
    if (!companion || companion === 'threshold' || companion === 'free') return;
    const codes = (cart.discount_codes || []).map((entry) => String(entry.code || '').toUpperCase());
    if (!codes.includes(offer.code.toUpperCase()) || codes.includes(companion.toUpperCase())) return;
    try {
      await fetch(`${root()}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: `${offer.code},${companion}` }),
      });
    } catch { /* The offer stands; the next cart read tries again. */ }
  }

  refresh();
  window.addEventListener('pageshow', (event) => { if (event.persisted) refresh(); });
  window.addEventListener('focus', () => refresh());
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, () => refresh());
})();
